import { environment } from '../environments/environment';
import { routing } from './app.routing';
import { AppComponent } from './app.component';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxMaskModule } from 'ngx-mask';
import { ToastrModule } from 'ngx-toastr';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';

import { AuthGuard } from './auth/_guards';
import { AuthComponent } from './auth/auth.component';
import { BlockUi } from './auth/_helpers';
import { LogoutComponent } from './auth/logout/logout.component';

import { AuthenticationService } from './_services/authentication.service';
import { SessionService } from './auth/_services/session.service';

import { HeaderNavComponent } from './theme/layouts/header-nav/header-nav.component';
import { PageHeaderComponent } from './theme/layouts/page-header/page-header.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';

import { CalledsComponent } from './pages/calleds/calleds.component';
import { CalledsListComponent } from './pages/calleds/calleds-list/calleds-list.component';
import { CalledDetailComponent } from './pages/calleds/called-detail/called-detail.component';
import { ContactusComponent } from './pages/contactus/contactus.component';
import { VetComponent } from './pages/vet/vet.component';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import { VetDetailComponent } from './pages/vet-detail/vet-detail.component';
import { VetDetailDataComponent } from './pages/vet-detail-data/vet-detail-data.component';
import { VetDetailConsultingComponent } from './pages/vet-detail-consulting/vet-detail-consulting.component';
import { PetsComponent } from './pages/pets/pets.component';
import { VetCreateComponent } from './pages/vet-create/vet-create.component';
import { VetListComponent } from './pages/vet/vet-list/vet-list.component';
import { PetsListComponent } from './pages/pets/pets-list/pets-list.component';
import { PetsCreateComponent } from './pages/pets-create/pets-create.component';
import { PetDetailComponent } from './pages/pet-detail/pet-detail.component';
import { PetDetailDataComponent } from './pages/pet-detail-data/pet-detail-data.component';
import { PetDetailConsultingComponent } from './pages/pet-detail-consulting/pet-detail-consulting.component';
import { PetDetailVaccineComponent } from './pages/pet-detail-vaccine/pet-detail-vaccine.component';
import { FlatpickrModule } from 'angularx-flatpickr';
import { CoreModule } from './auth/_core/core.module';
import { PetMakeAppointmentComponent } from './pages/pet-make-appointment/pet-make-appointment.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { PetDetailVaccineInsertComponent } from './pages/pet-detail-vaccine-insert/pet-detail-vaccine-insert.component';
import { MyPetsComponent } from './pages/my-pets/my-pets.component';
import { MyPetsListComponent } from './pages/my-pets/my-pets-list/my-pets-list.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { AppointmentStatusComponent } from './theme/layouts/appointment-status/appointment-status.component';
import { MyPetComponent } from './pages/my-pet/my-pet.component';
import { MyPetDataComponent } from './pages/my-pet/my-pet-data/my-pet-data.component';
import { MyPetTimelineComponent } from './pages/my-pet/my-pet-timeline/my-pet-timeline.component';
import { MyPetPhotosComponent } from './pages/my-pet/my-pet-photos/my-pet-photos.component';
import { MyPetAddPhotoComponent } from './pages/my-pet/my-pet-add-photo/my-pet-add-photo.component';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { PetDeleteComponent } from './pages/pet-delete/pet-delete.component';
import { VetRegistrationComponent } from './pages/vet-registration/vet-registration.component';
import { HttpClientModule } from '@angular/common/http';
import { AdmConfigComponent } from './pages/adm-config/adm-config.component';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    LogoutComponent,
    HeaderNavComponent,
    PageHeaderComponent,
    DashboardComponent,
    CalledsComponent,
    CalledsListComponent,
    CalledDetailComponent,
    ContactusComponent,
    VetComponent,
    VetDetailComponent,
    VetDetailDataComponent,
    VetDetailConsultingComponent,
    PetsComponent,
    VetCreateComponent,
    VetListComponent,
    PetsListComponent,
    PetsCreateComponent,
    PetDetailComponent,
    PetDetailDataComponent,
    PetDetailConsultingComponent,
    PetDetailVaccineComponent,
    PetMakeAppointmentComponent,
    PetDetailVaccineInsertComponent,
    MyPetsComponent,
    MyPetsListComponent,
    MyPetComponent,
    MyPetDataComponent,
    MyPetTimelineComponent,
    MyPetPhotosComponent,
    MyPetAddPhotoComponent,
    AppointmentStatusComponent,
    MyPetComponent,
    PetDeleteComponent,
    VetRegistrationComponent,
    AdmConfigComponent,
  ],
  imports: [
    BrowserModule,
    routing,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule.enablePersistence(),
    AngularFireAuthModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    FormsModule,
    NgbModalModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FlatpickrModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    AngularMultiSelectModule,
    CKEditorModule,
    NgxMaskModule.forRoot(),
    ToastrModule.forRoot({
      progressBar: true,
      timeOut: 3500,
      closeButton: true
    }),
    CoreModule.forRoot({}),
  ],
  providers: [AuthGuard, AuthenticationService, SessionService, BlockUi],
  bootstrap: [AppComponent]
})
export class AppModule { }
